export default {
  type: "Feature",
  properties: {
    name: "Дархан",
    location: [49.2669, 106.28311],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.138916015625, 49.81849300131474],
        [106.138916015625, 49.73335620733158],
        [106.07299804687499, 49.67829251994456],
        [106.04278564453125, 49.61782831211117],
        [106.14990234375, 49.58578744112238],
        [106.24603271484375, 49.5519436777949],
        [106.380615234375, 49.52164252537975],
        [106.46026611328125, 49.56085220619188],
        [106.49871826171875, 49.60893018211529],
        [106.67449951171875, 49.56085220619188],
        [106.7596435546875, 49.52877389852215],
        [106.80084228515625, 49.47169378524674],
        [106.80084228515625, 49.37164333826142],
        [106.7816162109375, 49.26601230654397],
        [106.7926025390625, 49.2032427441791],
        [106.79809570312499, 49.13320554247907],
        [106.600341796875, 49.086459027368335],
        [106.45477294921874, 49.12961122037019],
        [106.38336181640625, 49.15656228453343],
        [106.35314941406249, 49.18349869228674],
        [106.20758056640625, 49.163746759588975],
        [106.14715576171875, 49.14219020768315],
        [106.094970703125, 49.10444366870733],
        [106.051025390625, 49.095452162534826],
        [105.80108642578125, 49.1314084139986],
        [105.82305908203124, 49.15296965617039],
        [105.89447021484375, 49.44848596885694],
        [105.89309692382811, 49.506484903584074],
        [105.8642578125, 49.54125129864412],
        [105.8587646484375, 49.577773933420914],
        [105.83953857421874, 49.60715036117516],
        [105.8367919921875, 49.683623991698084],
        [105.92468261718749, 49.742231602580716],
        [106.0235595703125, 49.786584231227586],
        [106.138916015625, 49.81849300131474],
      ],
    ],
  },
};
